// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start()
require("@fortawesome/fontawesome-free")

import $ from 'jquery';  
window.jQuery = $; window.$ = $;

// The Rails Object is made available globally along with jQuery (see: config/webpack/environment.js) 
// and is needed by rails-ujs when submitting forms programmatically via javascript. It replaces
// the jQuery based form.submit() function with Rails.fire events

import Rails from "@rails/ujs";
window.Rails = Rails;

import 'bootstrap'

require("select2");
require("inputmask");

require('bootstrap4-toggle');

require('datatables.net-bs4');
require('datatables.net-select-bs4');

// Make Isotope a jQuery plugin
var jQueryBridget = require('jquery-bridget');
var Isotope = require('isotope-layout');
jQueryBridget( 'isotope', Isotope, $ );

import {Interactor} from 'm3n2-analytics';
window.Interactor = Interactor;

/* The date picker for choosing a custom date range. This is the only 
 *  combination that appears to work!
 */
global.moment = require('moment');
require('tempusdominus-bootstrap-4');

/* Uncomment to copy all static images under ../images to the output folder and reference
 * them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
 * or the `imagePath` JavaScript helper below.
 */
const images = require.context('../images', true)
const imagePath = (name) => images(name, true)
